import { useMemo } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button, NotificationDispatch, TextField } from '@tryhackme/thm-ui-components';
import { useForm } from 'src/common/form';
import { isQueryErrorWithMessage } from 'src/common/helpers/slices';
import { useUpdateUserWritesUpsMutation } from 'src/features/manage-room/manage-room.slice';
import { ManageRoomDetail } from 'src/features/manage-room/manage-room.types';
import { officialWriteUpsUrlValidations } from '../../write-ups.constants';
import { UpdateUserWriteUpsPayload, WriteUpDetails } from '../../write-ups.types';
import { FormRow } from '../../../form-row';
import { StyledBottomAdornment, StyledLoadingSpinner } from './official-write-up.styles';
export const OfficialWriteUp = ({
  roomDetails
}: {
  roomDetails: ManageRoomDetail;
}) => {
  const [updateUserWritesUps, {
    isLoading
  }] = useUpdateUserWritesUpsMutation();
  const defaultValues = useMemo(() => ({
    userWriteup: roomDetails?.userWriteup || ''
  }), [roomDetails]);
  const {
    register,
    handleSubmit,
    formState: {
      errors
    }
  } = useForm({
    resolver: yupResolver(officialWriteUpsUrlValidations),
    defaultValues,
    mode: 'onChange'
  });
  const onSubmit = async (values: WriteUpDetails) => {
    try {
      const {
        userWriteup
      } = values;
      const updateWriteUpsPayload: UpdateUserWriteUpsPayload = {
        url: userWriteup,
        code: roomDetails?.code || ''
      };
      await updateUserWritesUps(updateWriteUpsPayload).unwrap();
      NotificationDispatch('success', 'Official Write ups updated successfully.');
    } catch (error) {
      if (isQueryErrorWithMessage(error)) {
        if (error.status === 400) {
          NotificationDispatch('error', error.data.message);
        } else {
          NotificationDispatch('error', 'Uh-oh. There was an error while updating your write ups. Please try again.');
        }
      }
    }
  };
  return <FormRow heading="Official write-up" description="Public challenge rooms need to include a write-up." data-sentry-element="FormRow" data-sentry-component="OfficialWriteUp" data-sentry-source-file="official-write-up.tsx">
      <TextField {...register('userWriteup')} data-testid="user_write_up" id="user_write_up" variant="input" label="Write-up URL" bottomAdornment={<StyledBottomAdornment>Private link to download the write-up from</StyledBottomAdornment>} errorMessage={errors?.userWriteup?.message} isError={Boolean(errors.userWriteup)} rightOutsideAdornment={
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    <Button data-testid="action-button" variant="solid" color="add" onClick={handleSubmit(onSubmit)}>
            {isLoading && <StyledLoadingSpinner color="primary" />}
            {isLoading ? 'Updating' : 'Save'}
          </Button>} data-sentry-element="TextField" data-sentry-source-file="official-write-up.tsx" />
    </FormRow>;
};